var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.mediapath,"alt":_vm.coinname + '-logo'},on:{"error":_vm.imageLoadError}})}
var staticRenderFns = []

export { render, staticRenderFns }